// Resolves signOnDate/signOffDate from top-level fields or metadata fallback.
// Some clients store these in metadata (imported from external crew systems),
// while the UI writes to top-level fields. Top-level takes priority.
export function resolveCrewDates(member) {
  const signOnDate = member?.signOnDate || member?.metadata?.signOnDate || null;
  const signOffDate = member?.signOffDate || member?.metadata?.signOffDate || null;
  return { signOnDate, signOffDate };
}
